import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CssServicesService } from '../../../services/css-services.service';
import { PageCSSDeclaration } from '../../../services/css-services.service';
import { Subject, Subscription } from 'rxjs';
import { shareReplay, take, takeUntil } from 'rxjs/operators';
import { IframeCommunicationService } from '../../../services/iframe-communication.service';
import { ToggleSectionDirective } from '../theme-color-picker/toggle-section.directive';
import { EditorInputField } from '../../../editor-container/editor-model';
import { customIcons } from '../../dialogs/editor-dialog/custom-editor-icons';
import { NbIconLibraries } from '@nebular/theme';
import { ColorPickerPopoverComponent } from '../../dialogs/color-picker-popover/color-picker-popover.component';

@Component({
  selector: 'kve-background-input',
  templateUrl: './background-input.component.html',
  styleUrls: ['./background-input.component.scss']
})
export class BackgroundInputComponent implements OnInit,AfterViewInit,OnDestroy {
  @Input() popOver:boolean = false;
  @Input() field:EditorInputField;
  colors:string[] = [];
  color = "#fff";
  /* color = {
    h: 150,
    s: 0.50,
    l: 0.20,
    a: 1,
  }; */
  colorSubscription:Subscription;
  currentBgSubscription:Subscription;
  bgColors$:Subscription;
  pmColors$:Subscription;
  bgBasic:string[]=[];
  bgPrimary:string[]=[];
  bgAlt:string[]=[];
  fillColors:string[];
  primaryColors:string[]=[];

  /**
   * Target to set the color for.
   * Options: self, parent, container, cell, section, page
   */
  target:"string";
  property:"string";  // Property to set the color for, default is background-color
  
  component: any = ColorPickerPopoverComponent;

  private destroy$ = new Subject<void>();

  @ViewChild('optionPicker',{read:ElementRef}) optionPicker:ElementRef<HTMLElement>
  @ViewChild(ToggleSectionDirective) togglePickers;

  constructor(
    private cssService:CssServicesService,
    private communicator: IframeCommunicationService,
    private iconLibraries: NbIconLibraries) { 
    
  }
  
  
  ngOnInit(): void {
    this.iconLibraries.registerSvgPack('custom-icons',customIcons);
    if(this.field.value && this.field.value !== ""){
      console.log("Field Value: ",this.field.value)
      this.color = this.field.value;
    }
    if(this.field.context["target"] && this.field.context["target"] !== ""){
      this.target = this.field.context["target"];
    }
    if(this.field.context["property"] && this.field.context["property"] !== ""){
      this.property = this.field.context["property"];
    }
    /* this.colorSubscription = this.cssServices.getPageCSS()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      console.log("Color - Subscription")
        for (let [k,v] of Object.entries(data)) {
          this.colors.push(v);
        }
    }) */
    //this.communicator.send({id:'pageBgColor',data:pageBgColor})
    /* this.currentBgSubscription = this.cssServices.getCurrentPageBg()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      console.log(data)
      this.color = data;
    }) */
    this.currentBgSubscription = this.communicator.receive("pageBgColor").pipe(takeUntil(this.destroy$))
    .subscribe((info:any) => {
      console.log(info.data);
      this.color = info.data;
     })
    /* this.bgColors$ = this.communicator.receive("backgrounds").pipe(takeUntil(this.destroy$))
    .subscribe((data:any) => {
      console.log(data)
      let _bgColors = [];
      for (let [k,v] of Object.entries(data.data.options)) {
          _bgColors.push(<string>v);
        }
        this.colors = [];
        this.colors = _bgColors.splice(0,4).concat(_bgColors.splice(0,4),_bgColors.splice(0,4));
        
    }) */
    this.bgColors$ = this.cssService.getBgColors().pipe(take(1)).subscribe((colorKV:any[]) => {
          //console.log(colorKV);
          colorKV.forEach((colorObj,i) => {
            if(i < 4){
              this.bgBasic.push(colorObj.val)        
            }else if(i > 3 && i < 8){
              this.bgPrimary.push(colorObj.val)
            }else if(i > 7){
              this.bgAlt.push(colorObj.val)
            }
    
          })
          //this.fillColors = this.bgBasic.concat(this.bgPrimary).concat(this.bgAlt);
        });

        this.pmColors$ = this.cssService.getPmColors().pipe(take(1))
    .subscribe((colorKV:any[]) => {
      //console.log(colorKV)
      colorKV.forEach((colorObj) => {
        this.primaryColors.push(colorObj.val)
      })
      //console.log(this.primaryColors);
      this.fillColors = this.bgBasic.concat(this.primaryColors).concat(this.bgAlt);
    })


  }

  handleChangeComplete(e){
    
  }

  ngAfterViewInit(): void {
    
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
